import { offsetPaginationWithMaxLimitSchema } from '@crowdfpl/domain/pagination';
import { playerEntitySchema } from '@crowdfpl/domain/player';
import { playerTeamRefSchema } from '@crowdfpl/domain/team';
import { z } from 'zod';

export const PlayerTeamSchema = playerTeamRefSchema;
export const PlayerSchema = playerEntitySchema;

export const PlayersSearchResponseSchema = z.object({
  players: z.array(PlayerSchema),
  pagination: offsetPaginationWithMaxLimitSchema,
});

export type PlayerDto = z.infer<typeof PlayerSchema>;
export type PlayersSearchResponse = z.infer<typeof PlayersSearchResponseSchema>;
